import { Company } from "../../graphqlQueries/getCompanyNames";
import { DMOProductsToCheck } from "./DMOProductsToCheck";
import { HasuradbDmoArea } from "../../graphqlQueries/getCuratorAreas";
import React from "react";
import { breakpointPixels } from "../../css/breakpoints";
import styled from "styled-components";

const StyledNotificationWrapper = styled.div`
  .cardWrapper {
    &:first-child {
      width: 69%;
    }
    &:nth-child(2) {
      width: 30%;
    }
  }

  @media (max-width: ${breakpointPixels.xl}) {
    .cardWrapper {
      &:first-child {
        width: 100%;
      }
      &:nth-child(2) {
        width: 100%;
      }

      a:first-child {
        width: 100%;
      }
    }
  }
`;

type DMONotificationsProps = {
  company: Company;
  curatorAreas: HasuradbDmoArea[];
};

export const DmoNotifications = ({ company, curatorAreas }: DMONotificationsProps) => {
  const companyId = company.id;

  return (
    <StyledNotificationWrapper className="d-flex w-100 flex-wrap flex-xl-row flex-md-column justify-content-between">
      <div className="cardWrapper w-100">
        <DMOProductsToCheck companyId={companyId} curatorAreas={curatorAreas} />
      </div>
    </StyledNotificationWrapper>
  );
};
